import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  return (
    <header className="bg-card/80 backdrop-blur-md border-b border-border sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="rounded-lg overflow-hidden">
              <img 
                src="/lovable-uploads/a79795bc-cbdf-4383-a981-38b663a1e935.png" 
                alt="TrueTrucker IFTA Pro App Icon"
                className="h-10 w-10 object-cover"
              />
            </div>
            <div>
              <h1 className="text-xl font-bold text-foreground">TrueTrucker</h1>
              <p className="text-xs text-muted-foreground">IFTA Pro</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-foreground hover:text-primary transition-colors">
              Features
            </a>
            <a href="#pricing" className="text-foreground hover:text-primary transition-colors">
              Pricing
            </a>
            <a href="mailto:support@true-trucker-ifta-pro.com" className="text-foreground hover:text-primary transition-colors">
              Contact
            </a>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <div className="flex items-center space-x-4">
                <Button variant="ghost" onClick={() => navigate('/dashboard')}>
                  Dashboard
                </Button>
                <Button variant="premium" onClick={signOut}>
                  Log Out
                </Button>
              </div>
            ) : (
              <>
                <Button variant="premium" onClick={() => navigate('/auth?mode=signin')}>
                  Log In
                </Button>
                <Button variant="hero" size="lg" onClick={() => navigate('/auth?mode=signup')}>
                  Sign Up
                </Button>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-border pt-4">
            <nav className="flex flex-col space-y-4">
              <a href="#features" className="text-foreground hover:text-primary transition-colors">
                Features
              </a>
              <a href="#pricing" className="text-foreground hover:text-primary transition-colors">
                Pricing
              </a>
              <a href="mailto:support@true-trucker-ifta-pro.com" className="text-foreground hover:text-primary transition-colors">
                Contact
              </a>
              <div className="flex flex-col space-y-2 pt-4">
                {user ? (
                  <>
                    <Button variant="ghost" className="justify-start" onClick={() => navigate('/dashboard')}>
                      Dashboard
                    </Button>
                    <Button variant="premium" className="justify-start" onClick={signOut}>
                      Log Out
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="premium" className="justify-start" onClick={() => navigate('/auth?mode=signin')}>
                      Log In
                    </Button>
                    <Button variant="hero" onClick={() => navigate('/auth?mode=signup')}>
                      Sign Up
                    </Button>
                  </>
                )}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;